import { Capacitor } from "@capacitor/core";

/**
 * Configure iOS audio session with mixWithOthers and set/clear lock screen Now Playing.
 * Call with active:true BEFORE any audio (TTS, Web Audio) so Spotify/Music keeps playing.
 */
export const setStraivNowPlaying = (active: boolean, title = "Straiv - Run in progress") => {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "ios") return;
  try {
    const w = window as Window & {
      webkit?: { messageHandlers?: { straivNowPlaying?: { postMessage: (m: object) => void } } };
    };
    w.webkit?.messageHandlers?.straivNowPlaying?.postMessage({ active, title });
  } catch {}
};

/**
 * Prepare audio session before countdown - sets ambient + mixWithOthers so music doesn't pause.
 */
export const prepareAudioForRun = () => {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "ios") return;
  try {
    const w = window as Window & {
      webkit?: { messageHandlers?: { straivNowPlaying?: { postMessage: (m: object) => void } } };
    };
    w.webkit?.messageHandlers?.straivNowPlaying?.postMessage({ prepare: true });
  } catch {}
};

/**
 * Ask native to briefly release audio session so Spotify/Apple Music can resume, then reactivate for keep-alive.
 * Call ~600ms after run starts. Uses setActive(false, notifyOthersOnDeactivation) then reactivates after 200ms.
 */
export const resumeMusicAfterRunStart = () => {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "ios") return;
  try {
    const w = window as Window & {
      webkit?: { messageHandlers?: { straivNowPlaying?: { postMessage: (m: object) => void } } };
    };
    w.webkit?.messageHandlers?.straivNowPlaying?.postMessage({ resumeMusic: true });
  } catch {}
};

/**
 * Prepare for background keep-alive - sets playback + mixWithOthers so silent audio plays when phone is locked.
 * Ambient is silenced when locked; playback continues. mixWithOthers keeps music playing.
 */
export const prepareBackgroundKeepAlive = () => {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "ios") return;
  try {
    const w = window as Window & {
      webkit?: { messageHandlers?: { straivNowPlaying?: { postMessage: (m: object) => void } } };
    };
    w.webkit?.messageHandlers?.straivNowPlaying?.postMessage({ prepareBackgroundKeepAlive: true });
  } catch {}
};
